<div class="as-split-wrapper">
  <as-split direction="vertical" [useTransition]="true" (gutterClick)="onDblCLick()">
    <as-split-area [size]="10">
      <div class="px-4">
        <ebw-monorepo-raccordi-cavo-table
          #cavoTable
          [config]="raccordoCavoConfig$ | async"
          (fiberDetailRequested)="onFiberDetailRequested($event)"
          (reloadFiberRequested)="onReloadFiberRequested()"
          (onDeleteCavo)="checkEliminazioneCavo($event)"
        ></ebw-monorepo-raccordi-cavo-table>
      </div>
    </as-split-area>
    <as-split-area [size]="90" *ngIf="detailRequested">
      <div class="container-close d-flex justify-content-end">
        <button mat-icon-button mattooltip="Chiudi" (click)="detailRequested = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="detail-table-wrapper p-3 mb-3">
        <ebw-monorepo-sidebar-header
          [isSvg]="false"
          [icon]="'cable'"
          [title]="
            'map.sidebar.fibra.title'
              | translate
                : {
                    cable: selectedRaccordo.nome_cavo
                      ? selectedRaccordo.id_gis
                        ? selectedRaccordo.nome_cavo + ' - ID: ' + selectedRaccordo.id_gis
                        : selectedRaccordo.nome_cavo
                      : '/'
                  }
          "
        >
          <section class="d-flex flex-column align-items-start justify-content-center gap-2">
            <div class="d-flex flex-column align-items-start justify-content-center gap-1">
              <div>
                {{
                  !!selectedRaccordo.terminazione_1
                    ? ('map.sidebar.raccordo-cavo.table.terminazione_1' | translate | titlecase) +
                      ': ' +
                      selectedRaccordo.terminazione_1
                    : ('map.sidebar.raccordo-cavo.table.terminazione_1' | translate | titlecase) + ' non presente'
                }}
              </div>
              <div>
                {{
                  !!selectedRaccordo.terminazione_2
                    ? ('map.sidebar.raccordo-cavo.table.terminazione_2' | translate | titlecase) +
                      ': ' +
                      selectedRaccordo.terminazione_2
                    : ('map.sidebar.raccordo-cavo.table.terminazione_2' | translate | titlecase) + ' non presente'
                }}
              </div>
            </div>
            <div>{{ 'map.sidebar.fibra.info_section' | translate }}</div>
          </section>
        </ebw-monorepo-sidebar-header>
        <ebw-monorepo-fiber-table [config]="fibraConfig" (fetchDataEventEmitter)="fetchDataTableTrigger()"></ebw-monorepo-fiber-table>
      </div>
    </as-split-area>
  </as-split>
</div>
